module.exports = __webpack_public_path__ + "img/sidebar-open.95764e2f.svg";